
import React, { useMemo } from "react";
import MusicSkeleton from "./MusicSkeleton";

const MusicSectionSkeleton: React.FC = () => {
  const getEpisodesSkeletonArray = useMemo(() => {
    if (window.innerWidth < 768) {
      return [1];
    }
    if (window.innerWidth < 1280) {
      return [1, 2];
    }
    return [1, 2, 3];
  }, []);

  return (
    <div>
      <section className="relative radial-gradient-pink-bg w-full py-10 max-md:py-7">
        <div className="container relative max-md:px-4">
          <span className="block bg-gray-300 skeleton rounded mb-5 w-[338px] h-10"></span>
          <div
            className={`grid ${
              window.innerWidth < 768
                ? "grid-cols-1 mx-auto"
                : window.innerWidth < 1280
                ? "grid-cols-2"
                : "grid-cols-3"
            } gap-8 items-start z-[1] mt-6`}
          >
            {getEpisodesSkeletonArray.map((val) => {
              return <MusicSkeleton key={val} />;
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default MusicSectionSkeleton;
